import ConversationComponent from 'components/messaging/conversation';
import { FC } from 'react';

const ConversationPage: FC = () => {
  return <ConversationComponent url="/messaging/mentee-conversation" />;
};

export default ConversationPage;
